import Breadcrumbs from "../../../components/shared/Breadcrumbs/Breadcrumbs";
import BackToYachtButton from "../../../components/shared/BackToYachtButton/BackToYachtButton";
import { ButtonsWrapper, PageContainer } from "../../../styled";
import { useGetApi } from "../../../hooks";
import { getYachtId } from "../../../utils";
import ScrollableTable from "../../../components/shared/ScrollableTable/ScrollableTable";
import { headers } from "./GenericLoginsHeaders";
import { IGenericLoginsRow } from "../../../components/pages/Settings/GenericLogins/GenericLogins.types";
import { useCallback } from "react";
import type { IDraftEntry } from "../Miscellaneous/DraftEntries/DraftEntries";
import GenericLoginsRow from "../../../components/pages/Settings/GenericLogins/GenericLoginsRow";
import { Button } from "../../../components/shared/Button/Button";
import { IconPlus } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

const mapper = (data: any) => {
  if (!data?.list) return [];
  return Object.values(data.list) as IGenericLoginsRow[];
};

const GenericLogins = () => {
  const navigate = useNavigate();

  const { data } = useGetApi({
    request: "get-generic-logins",
    body: {
      params: { yachtid: getYachtId() },
    },
    mapper,
  });
  const handleAddLogin = () => {
    navigate("./add-login");
  };
  const renderRow = useCallback(
    ({ row }: { row: IGenericLoginsRow }) => <GenericLoginsRow {...row} />,
    [],
  );

  return (
    <PageContainer>
      <Breadcrumbs border={false}>
        <ButtonsWrapper>
          <Button
            onClick={handleAddLogin}
            leftSection={<IconPlus size="1.4rem" />}>
            Add
          </Button>
        </ButtonsWrapper>
      </Breadcrumbs>
      <div style={{ maxWidth: "1000px", width: "auto", margin: "0 auto" }}>
        <ScrollableTable
          data={data}
          keyExtractor={item => item.userid}
          headers={headers}
          renderRow={renderRow}
        />
      </div>
    </PageContainer>
  );
};
export default GenericLogins;
